import { type CreateAircraftDocumentInput } from '../../API';
import { getDb } from '../LocalDB/LocalDB';

export const getAircraftDocumentsForAircraft = async (aircraftId: string): Promise<CreateAircraftDocumentInput[]> => {
    return getDb().aircraftDocuments.where({ aircraftId }).toArray();
};
